export function isEven(num) {
    return num % 2 === 0;
}
